import React from 'react';
import { DoNotCallListPhoneNumber } from '../../../../../../../types/do-not-call-list';
import TruncatedTextWithTooltip from '../../../../../../../../../shared/components/truncated-text-with-tooltip';

type IProps = {
  phoneNumber: DoNotCallListPhoneNumber;
};

const PhoneNumberField: React.FC<IProps> = ({
  phoneNumber: { countryCode, phoneNumber },
}) => {
  const display = `${countryCode} ${phoneNumber}`.trim();
  return (
    <TruncatedTextWithTooltip
      length={40}
      string={display}
      tooltipClassName="tooltip-xxl"
    />
  );
};

export default PhoneNumberField;
